import {
  Link,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { RiMenuFill } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { useApp } from "../providers/app";
import { IoBagOutline } from "react-icons/io5";
import { FaFacebookF } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";
import { FiSearch } from "react-icons/fi";
import { useState, useEffect } from "react";
import axios from "axios";
import objectPath from "object-path";
import Dropdown from "./DropdownMenu";

const PublicMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, openDrawer, badge } = useApp();
  const location = useLocation();
  const [loading, setloading] = useState(false);
  const [search, setsearch] = useState(null);
  const { pathname } = location;
  const [menu, setmenu] = useState(null);
  useEffect(() => {
    const fetch = async () => {
      setloading(true);
      const result = await axios({
        url: "/service/type",
        method: "get",
        auth: {
          username: "hsct",
          password:
            "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
        },
      });
      const arr = objectPath.get(result, "data");

      const product = [];
      const sign = [];
      const poster = [];

      arr?.map((r) => {
        const classification = objectPath.get(r, "classification");
        const type = objectPath.get(r, "type");
        const _id = objectPath.get(r, "_id");
        if (classification == "product") {
          product.push({
            title: type,
            _id: _id,
          });
        }
        if (classification == "sign") {
          sign.push({
            title: type,
            _id: _id,
          });
        }
        if (classification == "poster") {
          poster.push({
            title: type,
            _id: _id,
          });
        }
      });

      setmenu([
        { title: t("public.menu.home"), url: "/order/home" },
        { title: t("public.menu.sign"), url: "/order/sign", items: sign },
        // { title: t("public.menu.road"), url: "/order/type/road" },
        { title: t("public.menu.poster"), url: "/order/poster", items: poster },
        { title: t("public.menu.create"), url: "/order/custom" },
        {
          title: t("public.menu.product"),
          url: "/order/product",
          items: product,
        },
        { title: t("public.menu.advice"), url: "/order/advice" },
      ]);
      setloading(false);
    };
    fetch();
  }, []);

  const openMobileMenu = () => {
    openDrawer(
      menu.map((menu, index) => {
        const { title, url, items } = menu;
        if (items) {
          return items?.map((item, itemIndex) => {
            return (
              <div
                key={itemIndex + 100}
                className={`${
                  pathname == url ? "text-primary font-semibold" : "text-black"
                } cursor-pointer`}
                // to={url}
                onClick={() =>
                  navigate(`/order/type/${objectPath.get(item, "_id")}`, {
                    state: { name: objectPath.get(item, "title") },
                  })
                }
              >
                <div className='py-2'>{objectPath.get(item, "title")}</div>
              </div>
            );
          });
        } else
          return (
            <NavLink
              key={index}
              className={`px-2 mx-2 ${
                pathname == url ? "text-primary font-semibold" : "text-black"
              }`}
              to={url}
            >
              <div>{`${title}`}</div>
            </NavLink>
          );
      })
    );
  };

  return (
    <div className={`shadow-md flex flex-col z-0`}>
      <div className='mx-auto w-full md:w-10/12 lg:w-10/12 sm:w-full flex flex-col'>
        <div className='flex flex-col md:flex-row items-center w-full'>
          <div className='flex flex-row items-center justify-between p-4 w-full'>
            <Link to='/order/home' className='flex items-center'>
              <img
                src='/logo.webp'
                alt='logo'
                className='h-10 b-'
                style={{ height: 49 }}
              />

              <div className='justify-center text-sm font-medium text-primary ml-2'>
                <div>HSCT</div>
                <div>LLC</div>
              </div>
            </Link>

            <div className='flex items-center justify-center'>
              <div className='hidden md:flex items-center bg-white border-2 w-32 md:w-96 text-sm rounded-full px-3 mr-2'>
                <input
                  placeholder={t("search")}
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                  onKeyDown={(e) => {
                    e.key === "Enter" && navigate(`/order/search/${search}`);
                  }}
                  className='border-none focus:outline-none focus:border-b-primary '
                />
                <FiSearch
                  className='hover:cursor-pointer'
                  onClick={() => navigate(`/order/search/${search}`)}
                  size={20}
                />
              </div>
              <NavLink to={"basket"} className='hover:cursor-pointer mb-2'>
                <div className='bg-primary text-white justify-center items-center flex rounded w-4 h-4 text-sm ml-4 '>
                  {badge}
                </div>
                <IoBagOutline color='#1A2E55' size={24} />
              </NavLink>
              <div
                className='lg:hidden md:hidden icon-button rounded-md border border-primary text-primary ml-4'
                onClick={openMobileMenu}
              >
                <RiMenuFill />
              </div>
            </div>
          </div>
          <div className='flex md:hidden pb-2 px-2 w-full'>
            <div className='md:hidden flex items-center bg-white border-2 w-full md:w-96 text-sm rounded-full px-3 mr-2'>
              <input
                placeholder={t("search")}
                value={search}
                onChange={(e) => setsearch(e.target.value)}
                onKeyDown={(e) => {
                  e.key === "Enter" && navigate(`/order/search/${search}`);
                }}
                className='border-none focus:outline-none focus:border-b-primary'
              />
              <FiSearch
                className='hover:cursor-pointer'
                onClick={() => {
                  navigate(`/order/search/${search}`);
                }}
                size={20}
              />
            </div>
          </div>
        </div>
        <div className='px-4 pb-2  h-0 md:flex md:h-12 invisible md:visible'>
          {loading ? (
            <div></div>
          ) : (
            menu?.map((menu, index) => {
              const { title, url, items } = menu;
              return items ? (
                <Dropdown title={title} items={items} />
              ) : (
                <NavLink
                  key={index}
                  className={`px-2 mx-2 ${
                    pathname == url
                      ? "text-primary font-semibold"
                      : "text-black"
                  }  cursor-pointer`}
                  to={url}
                >
                  <div>{t(`${title}`)}</div>
                </NavLink>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

const PublicFooter = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col border-t bg-primary p-4 absolute w-full bottom-0'>
      <div className='flex flex-wrap justify-between items-center'>
        <div className='flex items-center px-16'>
          {/* <div className="text-white font-medium cursor-pointer mx-4 text-sm">
            Бидний тухай
          </div> */}
          {/* <div className="text-white font-medium cursor-pointer mx-4 text-sm">
            Хийсэн ажлууд
          </div>
          <div className="text-white font-medium cursor-pointer mx-4 text-sm">
            Зөвлөгөө
          </div> */}
          {/* <div className="text-white font-medium cursor-pointer mx-4 text-sm">
            Холбоо барих
          </div> */}
        </div>
        <div className='flex items-center mx-4 w-full md:w-20 justify-center md:justify-between '>
          <a
            href='https://www.facebook.com/hsctmn#'
            className='flex items-center justify-center text-white  min-w-8 h-8 rounded hover:text-blue-700 hover:bg-white hover:cursor-pointer'
          >
            <FaFacebookF />
          </a>
          <a
            href='https://www.youtube.com/channel/UCJwWOPGATCOFuD9MgaMnt5g'
            className='flex items-center justify-center text-white  min-w-8 h-8 rounded hover:bg-red-700 hover:cursor-pointer'
          >
            <AiOutlineYoutube />
          </a>
        </div>
      </div>
      <div className='flex justify-center items-center p-2 text-center text-sm'>
        <div className='text-sm text-white font-normal'>{`©2025 ${t(
          "company"
        )}`}</div>
      </div>
    </div>
  );
};

const PublicLayout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <div className='w-full flex flex-col justify-between bg-background relative'>
      <PublicMenu />
      <div className='mx-auto w-full md:w-10/12 lg:w-10/12 sm:w-full bg-background  min-h-svh'>
        <Outlet />
      </div>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
